import { render, staticRenderFns } from "./SensorRelieveIcon.vue?vue&type=template&id=95af16f0&scoped=true"
import script from "./SensorRelieveIcon.vue?vue&type=script&lang=js"
export * from "./SensorRelieveIcon.vue?vue&type=script&lang=js"
import style0 from "./SensorRelieveIcon.vue?vue&type=style&index=0&id=95af16f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95af16f0",
  null
  
)

export default component.exports